export default {
  notifications: [],
  lastupdate: null
}
